/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.moderation.getActorMetadata'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  actor: /*#__PURE__*/ l.string({ format: 'did' }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  day: /*#__PURE__*/ l.ref<Metadata>((() => metadata) as any),
  month: /*#__PURE__*/ l.ref<Metadata>((() => metadata) as any),
  all: /*#__PURE__*/ l.ref<Metadata>((() => metadata) as any),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Metadata = {
  $type?: 'chat.bsky.moderation.getActorMetadata#metadata'
  messagesSent: number
  messagesReceived: number
  convos: number
  convosStarted: number
}

export type { Metadata }

const metadata = /*#__PURE__*/ l.typedObject<Metadata>(
  $nsid,
  'metadata',
  /*#__PURE__*/ l.object({
    messagesSent: /*#__PURE__*/ l.integer(),
    messagesReceived: /*#__PURE__*/ l.integer(),
    convos: /*#__PURE__*/ l.integer(),
    convosStarted: /*#__PURE__*/ l.integer(),
  }),
)

export { metadata }
